/* AB ab_flex_offer — sunsets 2026-10-31, delete src/pages/AB_FlexOfferSuivi/ */

/**
 * Unique agency IDs from the backend allowlist
 * (ets-request-manager-api/src/Experiments/FlexOffer/Config/FlexOfferAllowlistEntries.php).
 *
 * Duplicated here to gate the homepage link without an extra API call. If the backend
 * list changes before sunset, update this file in sync. Stale = extra/missing homepage
 * link for a few agencies; no correctness impact (dossier badge stays authoritative).
 */
export const AB_FLEX_OFFER_ALLOWLIST_AGENCY_IDS: ReadonlySet<number> = new Set([
    22, 28, 43, 118, 148, 156, 233, 251, 272, 295, 308, 352, 477, 1643, 2774, 2848, 3125, 3344,
    3379, 3397, 3503, 3527, 3684, 3742, 3975, 4279, 4744, 5531, 5695, 5747, 5769, 5840, 6454, 6679,
    67407, 67512, 68298, 68571, 68672, 68677, 68735, 68825, 68913, 68977, 68983, 69004, 69044,
    69059, 69125, 69137, 69161, 69236, 69293, 69441, 69559, 69579, 69580, 69645, 69664, 69770,
    69773, 69820, 69905, 69915, 69923, 69941, 69943, 69976, 69979, 69994, 69995, 69996, 70015,
]);
